import { TableHeadersType } from "./tableHeadersType";

export const ALL_EXTERNAL_USER_EMAILER_LIST_HEADERS: TableHeadersType[] = [
  {
    label: "USER NAME",
    value: "name",
    width:'18%'
  },
  {
    label: "CLIENT NAME AND CODE",
    value: "client_name",
    width:'20%'

  },
  {
    label: "EMAIL TEMPLATES",
    value: "emailer_settings",
    width:'40%'

  },
  {
    label: "Action",
    value: "action",
    width:'22%'

  },


];